import { useQuickProfile } from "@/context/QuickProfileContext";

// Clickable employee name that opens the Quick Profile account-info popup.
// Rendered as a span (not a button) so it can safely nest inside clickable cards/rows.
export const EmployeeName = ({ id, name, className = "", testid }) => {
  const { openQuickProfile } = useQuickProfile();
  if (!id) return <span className={`truncate ${className}`}>{name}</span>;
  const open = (e) => { e.stopPropagation(); openQuickProfile(id); };
  return (
    <span
      role="button"
      tabIndex={0}
      data-testid={testid}
      onClick={open}
      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") open(e); }}
      className={`cursor-pointer truncate transition-colors hover:text-[#0071E3] hover:underline ${className}`}
    >
      {name}
    </span>
  );
};

export default EmployeeName;
